import { Query, useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { getPricingCastAnywhereClusterCostsQueryKey } from 'hooks/queries/pricing/useCastAnywhereClusterPricingQuery';

export const useUpdateCastAnywherePricingMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiClient.pricing.updateCastAnywherePricing,
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: ({ queryKey }: Query) =>
          queryKey[0] === getPricingCastAnywhereClusterCostsQueryKey()[0],
      });
    },
  });
};
